import React, { Suspense, lazy, useEffect } from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { useAuthStore } from './stores/authStore';

import { ErrorBoundary } from './components/ErrorBoundary';

import Header from './components/Header';

import Footer from './components/Footer';

import AdminRoute from './components/AdminRoute';

import { startAuthTokenRefresh, stopAuthTokenRefresh } from './api/authTokenRefresh';

import { useProductsStore } from './stores/productsStore';

import './App.css';



const Home = lazy(() => import('./pages/Home'));

const Products = lazy(() => import('./pages/Products'));

const ProductDetail = lazy(() => import('./pages/ProductDetail'));

const Cart = lazy(() => import('./pages/Cart'));

const Checkout = lazy(() => import('./pages/Checkout'));

const Login = lazy(() => import('./pages/Login'));

const Register = lazy(() => import('./pages/Register'));

const VerifyEmail = lazy(() => import('./pages/VerifyEmail'));

const VerifyEmailPending = lazy(() => import('./pages/VerifyEmailPending'));

const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));

const ResetPassword = lazy(() => import('./pages/ResetPassword'));

const Admin = lazy(() => import('./pages/Admin'));

const CustomerService = lazy(() => import('./pages/CustomerService'));

const Registry = lazy(() => import('./pages/Registry'));

const GiftCards = lazy(() => import('./pages/GiftCards'));



function PageLoader() {

  return (

    <div

      className="flex min-h-[40vh] flex-1 items-center justify-center text-gray-500"

      role="status"

      aria-live="polite"

    >

      Loading…

    </div>

  );

}



function App() {

  useEffect(() => {

    void useAuthStore.getState().bootstrap();

    void useProductsStore.getState().prefetchCatalog();

    startAuthTokenRefresh();

    return () => stopAuthTokenRefresh();

  }, []);



  return (

    <Router>

      <div className="flex min-h-screen flex-col bg-white">

        <Header />

        <main className="flex-grow">

          <ErrorBoundary>

            <Suspense fallback={<PageLoader />}>

              <Routes>

                <Route path="/" element={<Home />} />

                <Route path="/products" element={<Products />} />

                <Route path="/product/:id" element={<ProductDetail />} />

                <Route path="/cart" element={<Cart />} />

                {/* Guest checkout — no login required */}

                <Route path="/checkout" element={<Checkout />} />

                <Route path="/customer-service" element={<CustomerService />} />

                <Route path="/registry" element={<Registry />} />

                <Route path="/gift-cards" element={<GiftCards />} />

                <Route path="/login" element={<Login />} />

                <Route path="/register" element={<Register />} />

                <Route path="/verify-email" element={<VerifyEmail />} />

                <Route path="/verify-email-pending" element={<VerifyEmailPending />} />

                <Route path="/forgot-password" element={<ForgotPassword />} />

                <Route path="/reset-password" element={<ResetPassword />} />

                <Route

                  path="/admin"

                  element={

                    <AdminRoute>

                      <Admin />

                    </AdminRoute>

                  }

                />

              </Routes>

            </Suspense>

          </ErrorBoundary>

        </main>

        <Footer />

      </div>

    </Router>

  );

}



export default App;

